import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { installFetchInterceptor } from './utils/fetchInterceptor';
import { initAnalytics } from './utils/analytics';

// Install global fetch interceptor to add Authorization headers automatically
installFetchInterceptor();

// Bootstrap GA4 / MS Clarity - no-op unless their env vars are set for this environment
initAnalytics();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);